import map_styles from './gmap-styles';
import createPopupClass from './gmap-popup';

(function ($, visceral) {

    if (visceral == null) {
        window.visceral = visceral = {};
    }
    visceral.map = {};

    const map_data = window.map_data || {};
    let google = null;
    // let info_window = null;
    let map = null;
    let Popup = null;

    visceral.map.init = function (items) {
        google = window.google;
        Popup = createPopupClass();

        $(items).each(function () {
            var item_el = this;
            var item = $(item_el);
            var id = item.data('mapId');
            var data = get_map_data(id);
            // var dynamic_bounds = new google.maps.LatLngBounds();

            // console.log('Initializing map', id, data);

            let initialCenter = new google.maps.LatLng(0.0343919, 18.2526165);
            map = new google.maps.Map(item_el, {
                disableDefaultUI: true,
                zoom: 3,
                minZoom: 4,
                center: initialCenter,
                styles: map_styles,
                gestureHandling: "cooperative",
                zoomControl: false,
            });
            // info_window = new google.maps.InfoWindow();

            map.addListener('click', function () {
                $('.popup-container').remove();
            });

            data.locations.forEach(location => {
                let position = new google.maps.LatLng(location.latitude, location.longitude);
                let marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: location.pin_path,
                    title: location.title,
                });

                marker.addListener('click', function () {
                    show_info(marker, location);
                    item.closest('.section').addClass('marker-clicked');
                });

                // dynamic_bounds.extend(position);
                // map.fitBounds(dynamic_bounds);
            });
        });
    }

    function show_info(marker, item) {
        // console.log('showing', item);
        var markup = render_map_info(item);

        $('.popup-container').remove();
        let container = $('<div id="map-popup"></div>').append(markup).appendTo('body');

        let coords = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        let css_class = "";

        if (item.permalink) {
            css_class = "has-permalink";
        }
        else {
            css_class = "no-permalink";
        }

        let popup = new Popup(coords, container[0], css_class);
        popup.setMap(map);
        map.setCenter(coords);
    }

    function render_map_info(item) {
        let markup = `
      <h3 class="info-window__title">${item.title}</h3>
      <div class="info-window__description">
        ${item.description}
      </div>
      `;

        if (item.permalink) {
            markup += `<div class="info-window__permalink"><a href="${item.permalink}" class="button btn">About this Site</a></div>`;
        }

        return markup;

    }

    function get_map_data(id) {
        return map_data[id];
    }

})(jQuery, window.visceral);


// WEBPACK FOOTER //
// ./scripts/map.js